import Vue from "vue";
import VueRouter from "vue-router";
import _ from "lodash";
import store from "@/store";
import {
  getPage,
  pagedefault
} from "@/plugins/PlatformSup.js";

Vue.use(VueRouter);

const routes = [{
    path: "/",

    beforeEnter: (to, from, next) => {
      next({
        name: "Login",
        params: {
          company: "Platform"
        }
      });
    }
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter: (to, from, next) => {
      localStorage.api_token = null;
      window.location.href = "/" + from.params.company + "/Login";
      // next({
      //   name: "Login",
      //   params: {
      //     company: to.params.company
      //   }
      // });
    }
  },
  {
    path: "/:company",
    name: "company",
    component: getPage("AppPage"),
    children: [{
        path: "index",
        name: "index",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("index")),
      }, {
        path: "Login",
        name: "Login",
        components: pagedefault(getPage("Login")),
      },
      {
        path: "order",
        name: "order",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("order/orderPage")),
        children: [
          {
            path: "orderManage",
            name: "myorder",
            component: getPage("myOrder", "views"),
          }
        ],
      },
      {
        path: "productManage",
        name: "productManage",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("productManagement", "views")),
        children: [{
            path: "proOverview",
            name: "proOverview",
            component: getPage("proOverview", "views/proManage"),
          },
          {
            path: "proEdit",
            name: "proEdit",
            component: getPage("proEdit", "views/proManage"),
            children: [{
                path: "proBaseField",
                name: "proBaseField",
                component: getPage("proBaseField", "views/proManage/proEdit"),
              },
              {
                path: "proCost",
                name: "proCost",
                component: getPage("proCost", "views/proManage/proEdit"),
              },
              {
                path: "proSpecification",
                name: "proSpecification",
                component: getPage("proSpecification", "views/proManage/proEdit"),
              },
              {
                path: "proStock",
                name: "proStock",
                component: getPage("proStock", "views/proManage/proEdit"),
              },
              {
                path: "proOther",
                name: "proOther",
                component: getPage("proOther", "views/proManage/proEdit"),
              },
            ],
          },
          {
            path: "proUploadImg",
            name: "proUploadImg",
            component: getPage("proUploadImg", "views/proManage"),
          },
          {
            path: "proClassify",
            name: "proClassify",
            component: getPage("proClassify", "views/proManage"),
          },
          {
            path: "proSortClass",
            name: "proSortClass",
            component: getPage("proSortClass", "views/proManage"),
          },
        ],
      },
      {
        path: "cartManage",
        name: "cartManage",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("cartManage", "views")),
        children: [{
            path: "fullDiscount",
            name: "fullDiscount",
            component: getPage("fullDiscount", "views/shoppingCart"),
          },
          {
            path: "totalDiscount",
            name: "totalDiscount",
            component: getPage("totalDiscount", "views/shoppingCart"),
          },
          {
            path: "discountSetting/:uid",
            name: "discountSetting",
            component: getPage("discountSetting", "views/shoppingCart"),
          },
          {
            path: "plus",
            name: "plus",
            component: getPage("plus", "views/shoppingCart"),
          }
        ],
      },
      {
        path: "memberinformation",
        name: "memberinformation",
        components: pagedefault(getPage("memberInfo", "views")),
      },
      {
        path: "changepassword",
        name: "changepassword",
        components: pagedefault(getPage("changePasswd", "views")),
      },
      {
        path: "courseleave",
        name: "courseleave",
        components: pagedefault(getPage("courseLeave", "views")),
      },
      {
        path: "onlineService",
        name: "onlineService",
        components: pagedefault(getPage("onlineService", "views")),
      },
      {
        path: "InsertProduct",
        name: "InsertProduct",
        components: pagedefault(getPage("InsertProduct", "views")),
      }, {
        path: "epaper",
        name: "epaper",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("epaperList", "views/epaper")),
      }, {
        path: "managerLetter/:uid",
        name: "managerLetter",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("newsletter", "views")),
      }, {
        path: "webSetting",
        name: "webSetting",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("webSetting", "views/webSetting")),
      },
      {
        path: "webManage",
        name: "webManage",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("webManage", "views/webSetting")),
      }, {
        path: "shipManage",
        name: "shipManage",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("shipManage", "views")),
        children: [{
            path: "shipBase",
            name: "shipBase",
            component: getPage("shipBase", `views/ship`),
          },
          {
            path: "shipTrack",
            name: "shipTrack",
            component: getPage("shipTrack", `views/ship`),
          },
        ],
      }, {
        path: "arrival",
        name: "arrival",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("arrival", "views")),
      }, {
        path: "printShip",
        name: "printShip",
        meta: {
          Login: true
        },
        components: pagedefault(getPage("printShip", "views")),
        children: [{
            path: "shipedList",
            name: "shipedList",
            component: getPage("shipedList", "views/printShip"),
          },
          {
            path: "waitConfirm",
            name: "waitConfirm",
            component: getPage("waitConfirm", "views/printShip"),
          },
        ],
      },
    ]
  },
];

const router = new VueRouter({
  base: "/",
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!store.state.system.company) {
    await store.dispatch("system/getcompany", to.params.company);
  }

  const checkmeber = to.matched;
  const ischeck = checkmeber.reduce((sum, item) => {
    return (sum) ? sum : !!item.meta.Login
  }, false);

  if (ischeck) {
    const check = await store.dispatch("Login/checkLogin");

    if (check) {
      next();
    } else {
      next({
        name: "index"
      });
    }
  }

  next();
});

export default router;
